import ListingsRoutingResolver from './ListingRoutingResolver';

class AccountingCashTillListingRoutingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "accounting-cashtill"
    }
}

export default AccountingCashTillListingRoutingResolver
